import { useDiaryByIdQuery } from "@/features/diaries/api";

import { hooks as h } from "@/hooks";
import { createFileRoute } from "@tanstack/react-router";
import { Lightbulb, Pointer } from "lucide-react";
import { isMobile } from "react-device-detect";
import { GradientBox } from "../../../../../components/common/GradientBox";
import { InfoBox } from "../../../../../components/common/InfoBox";
import DiaryCharts from "../../../../../features/charts/DiaryCharts";

const Chart = () => {
	const { diaryId } = Route.useParams();

	const { data: diary } = useDiaryByIdQuery(diaryId);

	h.useNav([
		{ label: "Diaries", route: { to: "/diaries" } },
		{
			route: { to: "/diaries/$diaryId/home/charts" },
			label: "Charts",
			options: [
				{ route: { to: "/diaries/$diaryId/home/new" }, label: "New" },
				{ route: { to: "/diaries/$diaryId/home/history" }, label: "History" },
				{ route: { to: "/diaries/$diaryId/home/charts" }, label: "Charts" },
			],
		},
	]);

	if (!diary) {
		return null;
	}

	return (
		<>
			<DiaryCharts diary={diary} />
		</>
	);
};

export const Route = createFileRoute("/_app/diaries/$diaryId/home/charts")({
	component: Chart,
});
